import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { PerStore } from '../stores/per.store';

export const PerSummaryGuard: CanMatchFn = () => {
  const perStore = inject(PerStore);
  const router = inject(Router);

  if (!perStore.loadingStatus().isLoaded) {
    return router.createUrlTree(['per', 'per-form']);
  }

  return true;
};
